export const initialShippingData = {
  street: "",
  number: "",
  postalCode: "",
  city: "",
  state: "",
  country: "",
}
export const initialUserData = {
  firstName: "",
  lastName: "",
  email: "",
}
export const initialOrderData = {
  paymentMethod: "",
  totalAmount: "",
}
